import { render, staticRenderFns } from "./CardBoard.vue?vue&type=template&id=f4765b14"
import script from "./CardBoard.vue?vue&type=script&lang=js"
export * from "./CardBoard.vue?vue&type=script&lang=js"
import style0 from "./CardBoard.vue?vue&type=style&index=0&id=f4765b14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports